import Entity from '../Entity';

export default class UserEpisodeReadingFinishTime implements Entity {
  constructor(
    public id: number,
    public userEpisodeReadingStartTimeId: number,
    public createdAt: Date,
    public updatedAT: Date,
  ) {}
}
